import debounce from '@utils/debounce';
document.querySelectorAll('.nav').forEach((element) => {
    const toggles = document.querySelectorAll('[data-toggle="nav"]');
    const page = document.querySelector('.page');
    const init = () => {
        if (!matchMedia('(min-width: 1024px)').matches) {
            element.style.visibility = 'hidden';
            element.setAttribute('aria-hidden', 'true');
        }
    };
    init();
    const reset = () => {
        var _a;
        element.removeAttribute('aria-hidden');
        element.removeAttribute('aria-modal');
        element.removeAttribute('role');
        element.style.visibility = '';
        (_a = window.scrollLock) === null || _a === void 0 ? void 0 : _a.enableScrolling();
    };
    const open = () => {
        var _a, _b;
        const menu = element.querySelector('.menu');
        (_a = menu === null || menu === void 0 ? void 0 : menu.MenuWidget) === null || _a === void 0 ? void 0 : _a.closeAll();
        element.classList.add('is-open');
        element.setAttribute('aria-hidden', 'false');
        element.setAttribute('aria-modal', 'true');
        element.setAttribute('role', 'dialog');
        element.style.visibility = 'visible';
        toggles.forEach((toggle) => {
            toggle.classList.add('active');
        });
        if (page)
            page.classList.add('page--nav-open');
        (_b = window.scrollLock) === null || _b === void 0 ? void 0 : _b.disableScrolling();
        element.dispatchEvent(new CustomEvent('open'));
    };
    const close = () => {
        var _a;
        element.classList.remove('is-open');
        element.setAttribute('aria-hidden', 'true');
        element.setAttribute('aria-modal', 'false');
        element.setAttribute('role', 'none');
        setTimeout(() => {
            element.style.visibility = 'hidden';
        }, 300);
        toggles.forEach((toggle) => {
            toggle.classList.remove('active');
        });
        if (page)
            page.classList.remove('page--nav-open');
        (_a = window.scrollLock) === null || _a === void 0 ? void 0 : _a.enableScrolling();
        element.dispatchEvent(new CustomEvent('close'));
    };
    const isOpen = () => element.classList.contains('is-open');
    toggles.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            if (isOpen()) {
                close();
            }
            else {
                open();
            }
        }, true);
    });
    document.addEventListener('keydown', (event) => {
        if ((event.code === 'Escape') && isOpen()) {
            close();
        }
    }, false);
    /*
      Принудительно закрываем и сбрасываем навигационную панель
      при расширении браузера за пределы мобильных разрешений
    */
    const handleResizePage = () => {
        if (matchMedia('(min-width: 1024px)').matches) {
            if (isOpen())
                close();
            setTimeout(reset, 310);
        }
    };
    window.addEventListener('resize', debounce(handleResizePage, 200));
});
